export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flat%20lay%20with%20designer%20accessories%20leather%20goods%20and%20textiles%20arranged%20artistically%2C%20warm%20golden%20hour%20lighting%2C%20soft%20cream%20and%20terracotta%20color%20palette%2C%20luxurious%20texture%20details%2C%20editorial%20magazine%20style%2C%20sophisticated%20composition%20with%20depth%20of%20field&width=1920&height=1080&seq=hero-main-2026-v2&orientation=landscape"
          alt="AllChinaBuySpreadsheet fashion product showcase"
          title="AllChinaBuySpreadsheet - China Product Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 text-center flex flex-col items-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-tight"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          AllChinaBuy<br />
          <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl italic font-light text-white/80" style={{ fontFamily: 'var(--font-heading)' }}>
            Spreadsheet
          </span>
        </h1>

        <p className="mt-6 md:mt-8 text-sm md:text-base text-white/70 max-w-xl leading-relaxed">
          The ultimate China product spreadsheet for winning dropshipping products. Curated supplier data, profit analysis, and TikTok-viral items — updated for 2026.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 md:mt-10 inline-flex items-center gap-2 px-10 py-4 bg-white text-foreground-900 rounded-full text-sm md:text-base font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
        >
          Buy It Now
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}